/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorTextPrimary = "#1A1A1A";
export const ColorTextSecondary = "#1A1A1A";
export const ColorBackgroundPrimary = "#FFF59B";
export const ColorIconPrimary = "#1A1A1A";
export const ColorIconSecondary = "#1A1A1A";
